import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { ResourceRecord } from '../entities/records';
import { resourcesByIds } from '../entities/Resource/selectors';

function mapStateToProps(state, { resourceIds }) {
  if (!resourceIds) return {};
  return {
    resources: resourcesByIds(state, resourceIds),
  };
}

export default compose(
  setPropTypes({
    resourceIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  }),
  connect,
  setPropTypes({
    resources: PropTypes.arrayOf(PropTypes.instanceOf(ResourceRecord)),
  }),
)(mapStateToProps);
